import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import $ from 'jquery';
import CorePage from '../../views/core/CorePage';


var defaultFontColor = "&color=%23000000";
var defaultFontName = "&fontFamily=Muli-Light";
var defaultFontSize = "&fontSize=13";

export default class AbstractQuestionView extends CorePage{
	constructor(props){
		super(props);

		this.filterHTML = this.filterHTML.bind(this);
		this.checkImageLoaded = this.checkImageLoaded.bind(this);

		try{
			this.WIRIS_URL = this.getUrlFor("WIRIS_URL");
			this.imageServiceUrl = this.WIRIS_URL + "/formula3/render?transparency=true";
		}catch(e){
			if(console)
				console.log("Error occurred in mathmlToimage | ",e);
		}
	}

	renderOptions() {		
		if (this.props.qdata.questionType === "mcq") {
			return (
				<div name="optionsVw">
			{/* Options: */}
			<ul className="qoption">
			{this.props.qdata.optionText.map(function (option, index) {
				return <li key={index}>{ReactHtmlParser(option)}</li>;
			})}

			</ul>
			</div>
			)
		} else {
			return (
				<div> </div>)
		}		
	}

	filterHTML(html) {
		return html;
		if(html !== null){
			var sb="";
			var pos = 0;
			var start;        
			while ((start = html.indexOf("<math", pos)) != -1) {
				sb+=(html.substring(pos, start));
				var autoclose = html.indexOf("/>", start);
				var greaterindex = html.indexOf(">", start);
	            if (autoclose != -1 && autoclose < greaterindex) { //autoclosed math tag
	            	pos = autoclose + "/>".length();
	            } else {
	            	pos = html.indexOf("</math>", start) + "</math>".length;
	            	var formula = html.substring(start, pos);
	            	var url = this.getImageUrl(formula);
	            	var img = "<img src=\""+url+ "\" align='middle' class='formula' />";
	            	sb+=img;
	            }
	        }
	        sb+=(html.substring(pos));
	        return sb.toString();
	    }
	}

	multiFibCheckFn(options){
		if(options && options.length>0){
			let optLeng = options.length;
			let corrAns = 0;
			let wrongAns = 0;
			let unAttempted = 0;
			options.map((option,index) => {
				if(option.optionCorrect){
					corrAns++;
				}else if (option.optionCorrect === false && option.userAns !== null) {
					wrongAns++;
				}else{
					unAttempted++;
				}
			});

			if(optLeng === corrAns) {
				return (
				<span><i className="material-icons corrans">done</i></span>
				)
			}else if (optLeng === unAttempted) {
				return (
				<span className="unans">{this.rb("scorecard.notattempted")}</span>
				)
			}else{
				return (
				<span><i className="material-icons wrgans">close</i></span>
				)
			}
		}
	}


	renderResultFn() {	
		let me=this;	
		if(this.props.qdata && (!this.props.qdata.attemptNo || this.props.qdata.attemptNo === 0)){
			return (
				<span className="unans">{this.rb("scorecard.notattempted")}</span>
				)
			}
			else if (this.props.qdata.optionResult && this.props.qdata.optionResult.length > 0) {
				return me.multiFibCheckFn(me.props.qdata.optionResult);
			}
			else {
				return (
				<span className="unans">{this.rb("scorecard.notattempted")}</span>
				)
			}
		}

		getQuestionNumber(){
			var qNo = 0;
			if(this.props.qno){
				qNo = this.props.qno;
			}

			if(this.props.qdata.testMode === "TEST"){
				return this.rb("questionview.q-label").replace("{1}",this.props.qno);
			}

			return this.rb("questionview.q-label.withattempt").replace("{1}",this.props.qno).replace("{2}",this.props.qdata.attemptNo);
		}

		getImageUrl(mathml, fontColor, fontSize, fontName) {
			var fontOptions = "";
			if(fontColor != null && fontColor != undefined) {
				fontOptions += "&color=%23" + fontColor;
			} else {
				fontOptions += defaultFontColor;
			}
			if(fontSize != null && fontSize != undefined) {
				fontOptions += "&fontSize=" + fontSize;
			} else {
				fontOptions += defaultFontSize;
			}
			if(fontName != null && fontName != undefined) {
				fontOptions += "&fontFamily=" + fontName;
			} else {
				fontOptions += defaultFontName;
			}
			// replace hack to remove <br> tag from mathml input to wiris editor service since latest versions 
	    // throws error for invalid inputs, which was previously rendered by older editor versions.
	    mathml = mathml.trim().replace("</math><br>","</math>");
	    var returnImage = this.imageServiceUrl + "&mml=" + encodeURIComponent(this.escapeUTF8Chars(mathml)) + fontOptions;
	    return returnImage;
	}
	
	escapeUTF8Chars(str) {
		var out = "";
		for(var i = 0; i < str.length; i++){
			var c = str.charCodeAt(i);
			if(c < 128) {
				out += str.charAt(i);
			} else {
				out += "&#" + c + ";";
			}
		}
		return out.trim();
	}
	checkImageLoaded(){	
		try{
			$('img').unbind("error");
			$('img').error(function(){		
				var me = this;
				var timeDelay = 5000;
				
				if(!$(me).attr('imageReloadCount')){
					$(me).attr('imageReloadCount',1);
				}
				
				timeDelay = timeDelay * parseInt($(me).attr('imageReloadCount'));			
				
				setTimeout(function()
				{ 				
					if(!$(me).attr('imageReloadCount')){
						$(me).attr('imageReloadCount',1);
					}else{
						$(me).attr('imageReloadCount',parseInt($(me).attr('imageReloadCount'))+1);
					}
					
					if($(me).attr('imageReloadCount')<=4){
						//console.log("timeDelay::",timeDelay);
						$(me).attr('src',$(me).attr('src'));
					}
					
					if(console){
						console.log("image not loaded :"+$(me).attr('src'));			
					}

				}, timeDelay);		
				
			}).load(function(){
				//console.log("loaded successfully...");
			});
		}
		catch(e){
			
		}
		
	}

	componentDidMount() {
		this.checkImageLoaded();
	}
	
	render() {
		var me = this;
		return (
			<div name="questionView" className="qvroot">
			<div className="qView scrollEqn">
		{/* <div className="quesorder">{"Q" + (this.props.qno + 1) + "."}</div> */}
		<div className="qvwList">
		<div className="quesorder">{this.getQuestionNumber()}
		<div className="qVw">
		<div name="questionVw scro">
		<div>
		{ReactHtmlParser(this.props.qdata.questionText)}
		</div>
		</div>

		{this.renderOptions()}

		<div name="userAnswerVw" className="anspadd">
		<span>{this.rb("scorecard.your_answer")}:</span>
		{this.renderResultFn()}
		{this.props.qdata.optionResult.map(function (optionObj, index) {
			if(me.props.qdata.attemptNo > 0){
				if(optionObj.unitPosition == 0){
					return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(optionObj.unit)} {ReactHtmlParser(me.filterHTML(optionObj.userAns))}</span>;
				}
				return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(me.filterHTML(optionObj.userAns))} {ReactHtmlParser(optionObj.unit)}</span>;
			}else{
				return <span className="mathml" key={index}>{ReactHtmlParser(me.filterHTML(optionObj.userAns))}</span>;
			}
		})}
		</div>

		<div name="correctAnswerVw" className="anspadd">
		<span>{this.rb("scorecard.correct_answer")}:</span>
		{this.props.qdata.optionResult.map(function (optionObj, index) {
			if(me.props.qdata.attemptNo > 0){
				if(optionObj.unitPosition == 0){
					return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(optionObj.unit)} {ReactHtmlParser(me.filterHTML(optionObj.correctAns))}</span>;
				}
				return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(me.filterHTML(optionObj.correctAns))} {ReactHtmlParser(optionObj.unit)}</span>;
			}else{
				return <span className="mathml" key={index}>{ReactHtmlParser(me.filterHTML(optionObj.correctAns))}</span>;
			}
		})}
		</div>
		</div>

		</div>



		</div>
		</div>

		<div name="solutionVw">
		<div className="qsoln scrollEqn">

		<p>{this.rb("editor.solutionTitle")}:</p>
		{ReactHtmlParser(this.props.qdata.solutionText)}
		</div>
		</div>

		</div>

		);
	}

}


// WEBPACK FOOTER //
// ./src/components/question/AbstractQuestionView.js